import {
  Toll,
  TollEditFormValues,
  TollRow,
} from "./types";

/*---------------------------------------------------------------------------------------
   TOLL
-----------------------------------------------------------------------------------------*/

export const transformToll = (res: any): Toll => {
  return {
    id: res.id,
    fromCcm: res.fromCcm,
    toCcm: res.toCcm,
    price: res.price,
  };
};

/*---------------------------------------------------------------------------------------
   TOLL SEARCH
-----------------------------------------------------------------------------------------*/

export const transformTollRow = (res: any): TollRow => {
  return {
    id: res.id,
    fromCcm: res.fromCcm,
    toCcm: res.toCcm,
    price: res.price,
  };
};

/*---------------------------------------------------------------------------------------
     TOLL CREATE
  -----------------------------------------------------------------------------------------*/

export const transformTollOnCreate = (
  formValues: TollEditFormValues
): any => ({
  fromCcm: formValues.fromCcm,
  toCcm: formValues.toCcm,
  price: formValues.price,
});

/*---------------------------------------------------------------------------------------
   TOLL EDIT
-----------------------------------------------------------------------------------------*/

export const transformTollOnUpdate = (
  formValues: TollEditFormValues
): any => ({
  id: formValues.id,
  fromCcm: formValues.fromCcm,
  toCcm: formValues.toCcm,
  price: formValues.price,
});

